<template>
  <v-container fluid>
    <v-layout row wrap>
      <v-flex class="d-flex justify-space-between mb-3 align-center" xs12>
        <h3 class="font-weight-bold">{{ routeLabel }}</h3>
        <refresh-button :click-function="fetchData" />
      </v-flex>

      <v-flex xs12 class="mb-4">
        <v-layout row wrap align-center>
          <v-flex xs12 md4 class="pr-2">
            <v-menu v-model="dateMenu" :close-on-content-click="false" transition="scale-transition" offset-y min-width="auto">
              <template v-slot:activator="{ on, attrs }">
                <v-text-field :value="formattedDateRange" label="Date Range" prepend-inner-icon="event"
                               outlined dense hide-details v-bind="attrs" v-on="on" />
              </template>
              <v-date-picker v-model="dateRangeValues" range no-title @change="onDateRangeChange" />
            </v-menu>
          </v-flex>
        </v-layout>
      </v-flex>

      <!-- Loading -->
      <v-flex v-if="loading" xs12 class="text-center py-12">
        <v-progress-circular color="primary" indeterminate size="48" />
        <div class="grey--text text--darken-1 mt-3">Loading statistics...</div>
      </v-flex>

      <!-- Empty -->
      <v-flex v-else-if="Object.keys(statistics).length === 0" xs12 class="text-center py-12">
        <v-icon size="64" color="grey lighten-1">info</v-icon>
        <div class="grey--text text--darken-1 mt-3">No statistics data available</div>
      </v-flex>

      <!-- Cards -->
      <template v-else>
        <v-flex v-for="(stat, key) in statistics" :key="key" xs12 md3 class="pa-2">
          <v-card class="white">
            <v-card-text>
              <div class="subtitle-2 grey--text text--darken-1 mb-2">{{ formatLabel(key) }}</div>
              <div v-for="(value, subKey) in stat" :key="subKey" class="body-1">
                <strong>{{ formatLabel(subKey) }}:</strong> {{ formatValue(value) }}
              </div>
            </v-card-text>
          </v-card>
        </v-flex>
      </template>
    </v-layout>
  </v-container>
</template>

<script>
import Http from "axios";
import { VERSIONED_API_URL } from "../../config/config";
import RefreshButton from "@/components/RefreshButton";

export default {
  name: "SummaryReportStatistics",
  components: { RefreshButton },

  data() {
    const yesterday = new Date();
    yesterday.setDate(yesterday.getDate() - 1);
    const yesterdayDate = yesterday.toISOString().split("T")[0];

    return {
      statistics: {},
      loading: false,
      dateRange: { start: yesterdayDate, end: yesterdayDate },
      dateMenu: false,
      dateRangeValues: [yesterdayDate, yesterdayDate],
    };
  },

  computed: {
    routeLabel() { return (this.$route && this.$route.meta && this.$route.meta.label) || "Summary Statistics"; },
    formattedDateRange() {
      const { start, end } = this.dateRange || {};
      if (start && end) return `${start} ~ ${end}`;
      return start || "";
    },
  },

  methods: {
    formatLabel(key) {
      return key.replace(/_/g, " ").replace(/\b\w/g, (l) => l.toUpperCase());
    },
    formatValue(value) {
      return typeof value === "number" ? value.toLocaleString() : value;
    },

    fetchData() {
      this.loading = true;
      const params = {};
      if (this.dateRange.start) params.start_date = this.dateRange.start;
      if (this.dateRange.end)   params.end_date   = this.dateRange.end;

      Http.get(`${VERSIONED_API_URL}/summary-report-data/statistics`, { params })
          .then((res) => { this.statistics = (res.data.data !== undefined ? res.data.data : res.data); })
          .catch((err) => console.error(err))
          .finally(() => { this.loading = false; });
    },

    onDateRangeChange(val) {
      if (val && val.length === 2) {
        const [a, b] = val.slice().sort();
        this.dateRange = { start: a, end: b };
        this.dateMenu = false;
        this.fetchData();
      }
    },
  },

  mounted() {
    this.fetchData();
  },
};
</script>